export default {
  en: {
    placeholder: 'Start writing',
    exitEditMode: 'Cancel edit',
  },
};
